module.exports = __webpack_public_path__ + "media/images/home/heart-306432d1d9c0a96b5ac2d19a5cc5a291.png";